import { Component } from 'react'
import PropTypes from 'prop-types'
import { applyMiddleware, combineReducers, createStore } from 'redux'
import thunk from 'redux-thunk'
import { Provider } from 'react-redux'
import Router from 'shared/universal-router'
import { Routes, Route } from 'react-router-dom-v5-compat'

import { getHistory } from 'lib/history'
import * as blUrls from 'lib/urls'

import registryReducer from 'registry/reducers'
import {
  SET_INSERT_CARD_ORDERS,
  SET_REGISTRY,
  SET_USER,
} from 'registry/actions'
import withCurrentUser from 'shared/HOC/withCurrentUser'
import onCurrentUserLoaded from 'shared/utils/onCurrentUserLoaded/onCurrentUserLoaded'
import InsertCardsSection from '../containers/insert-cards-section'
import ShareRegistryPage from '../components/share-registry-page'
import RegistryLinkSection from '../components/registry-link-section'
import { track, withContextualizedTracking } from 'lib/analytics'

let middlewares = [thunk]

if (process.env.NODE_ENV == 'development') {
  // middlewares.push(createLogger())
}

const createStoreWithMiddleware = applyMiddleware(...middlewares)(createStore)

class ShareRegistryApp extends Component {
  static propTypes = {
    insertCardOrders: PropTypes.array.isRequired,
    registry: PropTypes.object.isRequired,
    currentUser: PropTypes.object,
  }

  constructor(props) {
    super(props)
    this.store = createStoreWithMiddleware(combineReducers(registryReducer))

    this.store.dispatch({
      type: SET_USER,
      user: props.currentUser,
    })
    onCurrentUserLoaded((currentUser) => {
      if (currentUser) {
        this.store.dispatch({
          type: SET_USER,
          user: currentUser,
        })
      }
    })

    this.store.dispatch({
      type: SET_REGISTRY,
      registry: props.registry,
    })

    this.store.dispatch({
      type: SET_INSERT_CARD_ORDERS,
      insertCardOrders: props.insertCardOrders,
    })
  }

  render() {
    return (
      <Provider store={this.store}>
        <Router location={{ pathname: this.props.path }} useV6Router>
          <Routes>
            <Route
              path={blUrls.shareRegistryPath}
              element={<ShareRegistryPage />}
            >
              <Route index element={<RegistryLinkSection />} />
              <Route
                path={blUrls.shareRegistryLinkPath}
                element={<RegistryLinkSection />}
              />
              <Route
                path={blUrls.shareRegistryInsertCardsPath}
                element={<InsertCardsSection />}
              />
            </Route>
          </Routes>
        </Router>
      </Provider>
    )
  }
}

export default withContextualizedTracking({
  eventLocation: track.EventLocation.REGISTRY,
})(withCurrentUser(ShareRegistryApp))
